import { render, staticRenderFns } from "./videoHeat.vue?vue&type=template&id=2a7dce59&scoped=true"
import script from "./videoHeat.vue?vue&type=script&lang=js"
export * from "./videoHeat.vue?vue&type=script&lang=js"
import style0 from "./videoHeat.vue?vue&type=style&index=0&id=2a7dce59&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7dce59",
  null
  
)

export default component.exports